import { client } from '@/common-utils/libraries/axios/axios';
import DASHBOARD from '../apiUrls';
import SIM_POOLS_STATS_FIELDS from '../../fields/SimPoolsStatsFields';

const mapResponseData = (responseData) => {

    const data = {
        [SIM_POOLS_STATS_FIELDS.POOLS_OVER_80_PERCENT_COUNT.key]: responseData[SIM_POOLS_STATS_FIELDS.POOLS_OVER_80_PERCENT_COUNT.key],
        [SIM_POOLS_STATS_FIELDS.POOLS_OVER_LIMIT_COUNT.key]: responseData[SIM_POOLS_STATS_FIELDS.POOLS_OVER_LIMIT_COUNT.key]
    };

    return data;
};

const queryGetSimPoolsStats = (enabled = true) => {
    return {
        queryKey: [DASHBOARD.SIM_POOLS.queryKey],
        queryFn: async () => {
            const response = await client.get(DASHBOARD.SIM_POOLS.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetSimPoolsStats;